function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.684 34.5V18.991h5.307l.794-6.044h-6.101V9.088c0-1.75.495-2.942 3.053-2.942L18 6.144V.738C17.436.665 15.499.5 13.245.5 8.541.5 5.321 3.317 5.321 8.49v4.457H0v6.044h5.32V34.5h6.364z",
  fill: "#000"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 35",
    fill: "none"
  }, props), _ref);
}

export default SvgFacebook;